import { useSelector } from 'react-redux';
import { useGlobalLoading } from '../../../hooks/loadingHooks';
import { getIsLatestVersionOfCrmSuiteInProductInventoryPreSeatsAndSeatsOnlySelector, getIsLatestVersionOfProductInProductInventorySelector } from '../../../selectors/ProductInventorySelectors';
import { getTBSuiteProductForProductLevelSelector } from '../../../selectors/ProductsSelectors';
import { useIsFreePortal } from '../../../v2/hooks/useProductInventory';
import CurrentPlanTag from './CurrentPlanTag';
import { RecommendedBadge } from './RecommendedBadge';

/**
 * @description
 * This component is responsible for rendering only one badge at a time as we don't want to show multiple badges at once. This is similar to our BannerHierarchy component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const SuiteBadge = ({
  productLevel
}) => {
  const isAppReady = useGlobalLoading();
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const isCurrentPlanLevel = useSelector(state => {
    if (!isAppReady) {
      return false;
    }
    const suiteProduct = getTBSuiteProductForProductLevelSelector(state, {
      suiteProductLevel: productLevel
    });
    if (suiteProduct) {
      return getIsLatestVersionOfProductInProductInventorySelector(state, {
        productIdentifier: {
          apiName: suiteProduct === null || suiteProduct === void 0 ? void 0 : suiteProduct.apiName
        }
      });
    }
    return getIsLatestVersionOfCrmSuiteInProductInventoryPreSeatsAndSeatsOnlySelector(state, productLevel);
  });
  const showRecommendedBadge = isAppReady && !isInventoryLoading && isFreePortal && productLevel === 'STARTER';
  if (isCurrentPlanLevel) {
    return /*#__PURE__*/_jsx(CurrentPlanTag, {});
  }
  if (showRecommendedBadge) {
    return /*#__PURE__*/_jsx(RecommendedBadge, {});
  }
  return null;
};